import { render } from "./goUpVue.vue?vue&type=template&id=4b9c5aac&scoped=true"
import script from "./goUpVue.vue?vue&type=script&lang=js"
export * from "./goUpVue.vue?vue&type=script&lang=js"

import "./goUpVue.vue?vue&type=style&index=0&id=4b9c5aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9c5aac"]])

export default __exports__